import { TEXT_PLAIN, DATABASE_FIELD } from '../../../types/TransferTypes';
export default function onCut(event, database, next) {
  if (database.selection.isFocused) return next();
  var active = database.getActive();
  if (!active) return next();
  var text = database.run('serializeField', active);
  event.clipboardData.setData(TEXT_PLAIN, text);
  event.clipboardData.setData(DATABASE_FIELD, JSON.stringify(active));
  event.preventDefault();
  return next();
}